import type React from 'react';

import type { ClaimSideBarTab, SideBarKey } from '~/components/ClaimPage/hooks/useClaimSideBarTabs/utils';
import type { IconProps } from '~/components/icons/types';
import type { ClaimPolymorph } from '~/components/types/claim-types';
import type { OrganizationModel } from '~/components/types/organization-types';
import type {
  ClaimFieldsConfigurationsResponse,
  ClaimFieldsConfigurationsResponseAllClaimFieldsConfigurations,
  ClaimFieldsConfigurationsResponseClaimBarFieldConfiguration as ClaimBarFieldConfiguration,
  ClaimFieldsConfigurationsResponseClaimSidebarFieldConfiguration as ClaimSidebarFieldConfiguration,
} from '~/server_shared/openapi/data-contracts';
import type { Prettify } from '~/typescriptUtils';

export type ClaimFieldConfigType = Prettify<keyof ClaimFieldsConfigurationsResponseAllClaimFieldsConfigurations>;

export type { ClaimBarFieldConfiguration, ClaimFieldsConfigurationsResponse, ClaimSidebarFieldConfiguration };

export const CLAIM_FIELD_CONFIG_TYPE = {
  CLAIM_BAR: 'claim_bar',
  CLAIM_SIDEBAR: 'claim_sidebar',
} as const satisfies Record<string, ClaimFieldConfigType>;

export type ClaimFieldConfigurationMap = {
  [CLAIM_FIELD_CONFIG_TYPE.CLAIM_BAR]: ClaimBarFieldConfiguration;
  [CLAIM_FIELD_CONFIG_TYPE.CLAIM_SIDEBAR]: ClaimSidebarFieldConfiguration;
};

export interface ClaimPermissions {
  verb: string;
  action: string;
}

export interface ClaimSidebarTabProps {
  label: string;
  IconComponent: React.ComponentType<IconProps>;
  IconProps?: IconProps;
  url: string;
  isActive: boolean;
  match: {
    url: string;
    path: string;
  };
  claim: {
    id: number;
  };
  permissions?: ClaimPermissions;
  LabelComponent?: ClaimSideBarTab<SideBarKey>['LabelComponent'];
  labelComponentProps?: ClaimSideBarTab<SideBarKey>['labelComponentProps'];
  shouldReloadLegalActions?: boolean;
  reloadLegalActions: () => Promise<void>;
}

export interface UseCliveClaimSidebarTabsArgs {
  userOrganization: OrganizationModel;
  claim: ClaimPolymorph;
}
